export enum UrlValue {
  S = 'fusionId',
}

export type UrlParam = {
  [key in UrlValue]: string;
};

const decodeUrl = (url: string) => decodeURIComponent(url);

const getParamsInQueryString = (): UrlParam => { //TODO made UrlParam not partial
  const search = location.search.substring(1);

  const paramsDecoded = decodeUrl(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"');

  const validFusionIdParams = paramsDecoded.includes('fusionId');

  return validFusionIdParams ? JSON.parse(`{"${paramsDecoded}"}`) : {};
};

// todo polyfill IE11 URL & URLSearchParams
const setParamInQueryString = (key: string, value: string) => {
  const url = new URL(location.href);
  const searchParams = new URLSearchParams(url.search);
  searchParams.set(key, value);
  url.search = searchParams.toString();
  url.toString();
  history.replaceState({[key]: value}, '', url.search);
};

export const Url = {getParamsInQueryString, setParamInQueryString};
